export enum LookupType {
	String = 0,
	Number = 1,
	Tree = 2,
	Resource = 3,
	Project = 4,
	Rbs = 5,
	AutoNumber = 6,
}